import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "@/assets/css/input.css"
import Input from "./Input"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { forwardRef } from "react"
import { capitalizeFirstLetter } from "@/app/utils/helpers"

const InputDropdown1 = forwardRef(({ regions, disabled = false, errors, reqRegions = false, atKeyPress = () => { }, onSelectRegion = () => { }, onClickGlass = () => { } }, ref) => {
  const handleKeyDown = (e) => {
    atKeyPress(e)
  }

  const handleSelectedRegion = (region) => {
    onSelectRegion(region)
  }

  const handleClickGlass = () => {
    onClickGlass()
  }

  return (
    <div className="mb-3 relative">
      <div className="relative">
        <Input type="text" shouldUseEnterKeyHint disabled={disabled} onKeyPress={handleKeyDown} id="region" name="region" isInput2 noLabel placeholder="Province, City, Subdistrict" borderColor="border-[#bc9c5c]" custCls={errors.region ? "border-red-600 pl-6" : "pl-6"} errMsg={errors.region} ref={ref.regionRef} />
        <button type="button" onClick={handleClickGlass} className="text-[#9f978e] absolute top-2 left-2">
          <FontAwesomeIcon icon={faMagnifyingGlass} size="xs" />
        </button>
      </div>
      <div ref={ref.searchRegionRef} className="hidden absolute top-11 h-44 overflow-y-scroll w-full bg-white border-[1.5px] border-[#bc9c5c] border-opacity-20 font-agcasmlt font-light text-base py-2 px-2">
        <ul>
          {!reqRegions ?
            regions && regions.length > 0 ?
              regions.map((r, i) =>
                <li key={i} onClick={() => handleSelectedRegion(r)} className="font-agcasmlt font-light text-base text-charcoal-black py-2 px-2 cursor-pointer hover:bg-light-gray">
                  {capitalizeFirstLetter(r.label)}
                </li>
              )
              :
              <li className="font-agcasmlt font-light text-base text-[#9f978e] py-2 px-2 cursor-pointer hover:bg-light-gray">Location not found</li>
            :
            <li className="font-agcasmlt font-light text-base text-[#9f978e] py-2 px-2 cursor-pointer hover:bg-light-gray">
              Requesting locations ...
            </li>
          }
        </ul>
      </div>
    </div>
  )
})

export default InputDropdown1